import React from 'react'

const Copyright = () => {
    return (
        <div className="copyright-area copyright-style-one">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-8 col-sm-12 col-12">
                        <div className="copyright-left">                           
                            <p className="copyright-text">© Donegà Narciso di Donegà Gino {new Date().getFullYear()}</p>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-4 col-sm-12 col-12">
                        <div className="copyright-right text-right text-md-right">
                        <p className="copyright-text">Web design by <a href="https://www.pizziweb.it">Pizzi Web Solutions</a></p>                     
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Copyright;